module.exports = __webpack_public_path__ + "img/ST.c3baaa86.png";